import Client from './client';

export default class RestrictionFilters extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/filters`, options);
  }

  getCatalog(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/filters/catalog`, options);
  }

  getPendingReviews(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/filters/pending_reviews`, options);
  }

}
